(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-js"] && !Shopify.designMode) return;
  try {
    const jqueryLoaded = (cb) => {
    if (typeof $ === 'function') return cb();

    let tries = 40;
    const interval = setInterval(() => {
      if (typeof $ === 'function' || !--tries) {
        cb();
        clearInterval(interval);
      }
    }, 20);
  };

  const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints;

  // Differentiate between mobile and touch screen laptops
  window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

  const isElementOffRight = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.right > window.innerWidth;
  };

  const navThrottle = (func, limit) => {
    let inThrottle;
    return (...args) => {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  };

  const closeDropdown = () => {
    document.body.classList.remove('is-active');
    document.querySelectorAll('.dropdown_link').forEach(link => link.classList.remove('active_link'));
    document.querySelectorAll('.dropdown_container').forEach(container => container.style.display = 'none');
    document.querySelectorAll('.mobile_nav > span').forEach(div => div.classList.remove('open'));
  };

  const closeMiniCart = () => {
    document.body.classList.remove('is-active', 'blocked-scroll');
    document.querySelectorAll('.dropdown_link').forEach(link => link.classList.toggle('active_link'));
    document.querySelectorAll('.cart-container').forEach(container => container.classList.remove('active_link'));
  };

  const openMiniCart = (cartContainer) => {
    document.body.classList.add('blocked-scroll');
    document.querySelectorAll('.mobile_nav > span').forEach(div => div.classList.remove('open'));
    document.querySelectorAll('.dropdown_link').forEach(link => link.classList.remove('active_link'));
    cartContainer.classList.add('active_link');
  };

  const closeAllSubSubmenus = () => {
    document.querySelectorAll('.vertical-menu_sub-submenu').forEach(submenu => {
      submenu.classList.remove('is-visible');
      submenu.previousElementSibling.dataset.clickCount = '0';
    });
  };

  const closeAllSubmenus = () => {
    document.querySelectorAll('.vertical-menu_submenu').forEach(submenu => {
      submenu.classList.remove('is-visible');
      submenu.previousElementSibling.dataset.clickCount = '0';
    });
    document.querySelectorAll('.mega-menu-parent').forEach(parent => {
      parent.dataset.clickCount = '0';
    });
    closeAllSubSubmenus();
  };

  const openDropdownOnClick = document.querySelectorAll('.main-nav__wrapper [data-show-dropdown-on-click]');

  if (document.querySelector('.dropdown_link--vertical')) {
    document.querySelectorAll('.dropdown_link--vertical, .mega-menu-parent').forEach(el => {
      el.dataset.clickCount = '0';
    });

    if (!openDropdownOnClick.length) {
      document.querySelectorAll('.dropdown_link--vertical, .vertical-menu_submenu').forEach(element => {
        element.addEventListener('mouseover', (e) => {
          const current = e.currentTarget;
          const dropdown = element.closest('.main-nav')?.querySelector(`[data-dropdown="${element.dataset.dropdownRel}"]`);
          if (!dropdown) return;
          document.querySelectorAll('.dropdown_container').forEach(container => container.style.display = 'none');
          document.querySelectorAll('.active_link').forEach(link => link.classList.remove('active_link'));
          if (!element.classList.contains('active_link')) {
            document.querySelectorAll('.dropdown_container').forEach(container => container.style.display = 'none');
            current.classList.add('active_link');
            document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.add('feature_image'));
          }
        });
      });

      // Keep the decorative after element visible while hovering the submenu (desktop only)
      document.querySelectorAll('.vertical-menu li.sublink').forEach(item => {
        const trigger = item.querySelector('.dropdown_link--vertical');
        const submenu = item.querySelector('.vertical-menu_submenu');
        if (!trigger || !submenu) return;

        const addState = () => trigger.classList.add('submenu-open');
        const removeState = () => trigger.classList.remove('submenu-open');

        trigger.addEventListener('mouseenter', addState);
        trigger.addEventListener('mouseleave', () => {
          if (!submenu.matches(':hover')) {
            removeState();
          }
        });
        submenu.addEventListener('mouseenter', addState);
        submenu.addEventListener('mouseleave', removeState);
      });
    }

    if (isTouchDevice() || openDropdownOnClick.length >= 1) {
      document.body.addEventListener('touchstart', handleMenuClick);
      document.body.addEventListener('click', handleMenuClick);

      function handleMenuClick(e) {
        const verticalMenu = e.target.closest('.vertical-menu .sublink a, .vertical-menu_submenu .sublink a');
        if (!verticalMenu) return;

        const dropdownVertical = verticalMenu.nextElementSibling;
        const dropdownVerticalSubMenu = verticalMenu.nextElementSibling;

        const showMenu = () => {
          dropdownVertical.classList.remove('hidden');
          dropdownVerticalSubMenu.classList.remove('hidden');
          dropdownVertical.classList.add('is-visible');
          dropdownVerticalSubMenu.classList.add('is-visible');
        };

        let clicked = e.type === 'touchstart';
        if (clicked && verticalMenu.dataset.clickCount < 1) {
          openDropdown(verticalMenu, e.target);
          e.preventDefault();
          e.stopPropagation();
        } else if (e.type === 'click' && !clicked && verticalMenu.dataset.clickCount < 1) {
          openDropdown(verticalMenu, e.target);
          e.preventDefault();
          e.stopPropagation();
        }

        function openDropdown(menu, target) {
          const dropdownMegaMenu = menu.closest('.main-nav')?.querySelector(`[data-dropdown="${menu.dataset.dropdownRel}"]`);
          if (!dropdownMegaMenu) return;
          let clickCount = parseInt(menu.dataset.clickCount) || 0;

          document.querySelectorAll('.dropdown_link--vertical').forEach(link => {
            if (link !== menu) link.dataset.clickCount = '0';
          });
          document.querySelectorAll('.mega-menu-parent').forEach(parent => {
            parent.dataset.clickCount = '0';
          });
          document.querySelectorAll('.dropdown_link--vertical').forEach(link => {
            link.dataset.noInstant = 'true';
          });
          document.querySelectorAll('.dropdown_container').forEach(container => {
            container.style.display = 'none';
          });

          dropdownMegaMenu.style.display = 'block';
          if (target.closest('.vertical-menu_submenu')?.classList.contains('is-visible')) {
            closeAllSubSubmenus();
            document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.add('feature_image'));
          } else {
            closeAllSubmenus();
            document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.add('feature_image'));
          }

          showMenu();
          clickCount++;
          menu.dataset.clickCount = clickCount;

          if (clickCount < 2) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }

      document.documentElement.addEventListener('click', (event) => {
        if (!event.target.closest('.dropdown_container') && !event.target.classList.contains('url-deadlink')) {
          closeAllSubmenus();
          document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.add('feature_image'));
        }
      });
    }
  }

  document.querySelectorAll('.vertical-menu_submenu, .vertical-menu_sub-submenu').forEach(menu => {
    if (isElementOffRight(menu)) {
      menu.classList.add('vertical-menu--align-right');
    }
  });

  document.documentElement.addEventListener('click', (event) => {
    if (!event.target.closest('.cart-container') && document.querySelector('.cart_content')?.offsetParent) {
      closeMiniCart();
    }

    if (!event.target.closest('.dropdown_container') && document.querySelector('.dropdown')?.offsetParent &&
        !event.target.classList.contains('url-deadlink') && !event.target.classList.contains('mega-menu-parent')) {
      document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.add('feature_image'));
      document.body.classList.remove('is-active');
      closeDropdown();
      if (openDropdownOnClick.length) {
        document.querySelectorAll('.dropdown_link').forEach(link => link.dataset.clickCount = '0');
      }
    }
  });

  if (Shopify.media_queries.large.matches) {
    const header = document.querySelector('.header');
    if (header?.classList.contains('header-fixed--true')) {
      document.body.addEventListener('click', (e) => {
        const anchor = e.target.closest('.banner a[href^="#"]');
        if (anchor) {
          e.preventDefault();
          const anchorLink = anchor.getAttribute('href');
          const headerHeight = document.querySelector('.main-nav__wrapper.sticky_nav')?.offsetHeight || 0;
          const target = document.querySelector(anchorLink);
          if (target) {
            window.scrollTo({
              top: target.offsetTop - headerHeight,
              behavior: 'smooth'
            });
          }
        }
      });

      if (!document.querySelector('.main-nav__wrapper.sticky_nav')) {
        const navWrapper = document.querySelector('.main-nav__wrapper');
        if (navWrapper) {
          let isSticky = false;
          const onScroll = () => {
            const scrollPosition = window.scrollY;
            if (scrollPosition > 700 && !isSticky) {
              navWrapper.classList.add('sticky_nav', 'sticky_nav--stick');
              isSticky = true;
              const cartContainer = document.querySelector('.header .cart-container')?.cloneNode(true);
              if (cartContainer) {
                navWrapper.querySelector('.main-nav')?.appendChild(cartContainer);
              }
            } else if (scrollPosition <= 700 && isSticky) {
              navWrapper.classList.remove('sticky_nav--stick');
              navWrapper.classList.add('sticky_nav--unstick');
              isSticky = false;
              document.querySelectorAll('.cart-container').forEach(container => container.classList.remove('active_link'));
            }
          };
          window.addEventListener('scroll', navThrottle(onScroll, 300));
        }
      }
    }
  }

  const removeDataAttributes = (target) => {
    const elements = document.querySelectorAll(target);
    
    elements.forEach(element => {
      const attributes = Array.from(element.attributes);
      const dataAttrsToDelete = attributes
        .filter(attr => attr.name.startsWith('data-'))
        .map(attr => attr.name);
      dataAttrsToDelete.forEach(attr => element.removeAttribute(attr));
    });
  };

  const loadMegaMenu = () => {
    document.querySelectorAll('.sticky_nav .mega-menu, .header .mega-menu').forEach(menu => menu.remove());

    const megaMenus = document.querySelectorAll('.mega-menu-container .mega-menu');
    megaMenus.forEach(menu => {
      const clone = menu.cloneNode(true);
      const stickyNavMain = document.querySelector('.sticky_nav .main-nav');

      if (stickyNavMain) {
        stickyNavMain.appendChild(clone);
      }

      removeDataAttributes('.sticky_nav .mega-menu.dropdown_container .dropdown_column');

      const megaMenuValue = menu.dataset.dropdown;
      const parentLinks = document.querySelectorAll(`[data-dropdown-rel="${megaMenuValue}"]`);

      parentLinks.forEach(link => {
        link.querySelectorAll('span').forEach(span => span.remove());
        if (!link.classList.contains('icon-search')) {
          link.insertAdjacentHTML('beforeend', ' <span class="icon-down-arrow"></span>');
          link.classList.add('mega-menu-parent', 'dropdown_link');
          link.classList.remove('top_link');
        }
      });

      document.querySelectorAll(`[data-dropdown="${megaMenuValue}"]`).forEach(dropdown => {
        if (!dropdown.classList.contains('mega-menu')) {
          dropdown.remove();
        }
      });

      const headerMainNav = document.querySelector('.header .main-nav') || document.querySelector('.header-desktop')
      if (headerMainNav) {
        headerMainNav.appendChild(menu.cloneNode(true));
      }
    });

    if (document.querySelector('.dropdown_link--vertical')) {
      document.querySelectorAll('.dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu').forEach(submenu => submenu.remove());
      document.querySelectorAll('.dropdown_link--vertical:not(.mega-menu-parent)').forEach(link => {
        const megaMenuValue = link.dataset.dropdownRel;
        document.querySelectorAll(`[data-dropdown="${megaMenuValue}"]`).forEach(dropdown => dropdown.remove());
      });
    }

    const openDropdownOnClick = document.querySelectorAll('.main-nav__wrapper [data-show-dropdown-on-click]');
    if (openDropdownOnClick.length) {
      document.querySelectorAll('.mega-menu-parent').forEach(parent => {
        parent.addEventListener('click', (e) => {
          if (!parent.classList.contains('active_link')) {
            document.querySelectorAll('.dropdown_container').forEach(container => container.style.display = 'none');
            const dropdown = parent.closest('.main-nav')?.querySelector(`[data-dropdown="${parent.dataset.dropdownRel}"]`);
            if (dropdown) {
              dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
              parent.classList.add('active_link');
              document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.remove('feature_image'));
            }
          }
        });
      });
    }

    removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');

    if (isTouchDevice() || window.matchMedia('(max-width: 991px)').matches) {
      document.querySelectorAll('.dropdown_link').forEach(link => {
        link.dataset.noInstant = 'true';
      });
    }

    loadMobileMegaMenu();
  };

  const loadMobileMegaMenu = () => {
    document.querySelectorAll('.mega-menu-container .mobile-mega-menu').forEach(menu => {
      const parent = document.querySelector(`[data-mobile-dropdown-rel="${menu.dataset.mobileDropdown}"]`);
      if (parent) {
        parent.querySelectorAll('span').forEach(span => span.remove());
        const parentAnchor = parent.querySelector('a');
        if (parentAnchor) {
          parentAnchor.insertAdjacentHTML('beforeend', ' <span class="right icon-down-arrow"></span>');
          parentAnchor.dataset.noInstant = 'true';
        }
        parent.classList.add('mobile-mega-menu-parent', 'sublink');
        parent.appendChild(menu);
        parent.querySelectorAll('ul').forEach(ul => {
          if (!ul.classList.contains('mobile-mega-menu')) {
            ul.remove();
          }
        });
      }
    });
  };

  const unloadMegaMenu = () => {
    document.querySelectorAll('.header .mega-menu').forEach(menu => menu.remove());
    document.querySelectorAll('.mega-menu-container .mega-menu').forEach(menu => {
      const parent = document.querySelector(`.mega-menu-parent[data-dropdown-rel="${menu.dataset.dropdown}"]`);
      if (parent) {
        parent.querySelectorAll('.icon-down-arrow').forEach(arrow => arrow.remove());
      }
    });
  };

  const unload = () => {
    if (typeof handleBodyClick !== 'undefined') document.body.removeEventListener('click', handleBodyClick);
    document.querySelectorAll('.mobile_nav').forEach(nav => nav.replaceWith(nav.cloneNode(true)));
    document.querySelectorAll('.dropdown_link').forEach(link => link.replaceWith(link.cloneNode(true)));
    if (typeof handleHtmlClick !== 'undefined') document.documentElement.removeEventListener('click', handleHtmlClick);
    document.querySelectorAll('.mini_cart').forEach(cart => cart.replaceWith(cart.cloneNode(true)));
    document.querySelectorAll('.cart_content__continue-shopping').forEach(btn => btn.replaceWith(btn.cloneNode(true)));
    document.querySelectorAll('.banner a[href^="#"]').forEach(anchor => anchor.replaceWith(anchor.cloneNode(true)));
    document.querySelectorAll('.main-nav__wrapper.sticky_nav').forEach(nav => nav.remove());
  };

  loadMegaMenu();

  const mobileAccordion = (container, tab, content) => {
    const $container = document.querySelector(container);
    if (!$container) {
      console.warn(`Container "${container}" not found.`);
      return;
    }

    // Initialize accordion
    const initializeAccordion = () => {
      document.querySelectorAll(`${tab}.active`).forEach(($tab) => {
        const $content = $tab.nextElementSibling;
        if ($content && $content.matches(content)) {
          $content.classList.add('active');
          $content.style.height = `${$content.scrollHeight}px`;
          // Show corresponding CTA
          const relValue = $tab.parentElement?.getAttribute('data-mobile-dropdown-rel');
          if (relValue) {
            document.querySelectorAll(`.menu__cta[data-dropdown-rel-cta="${relValue}"]`).forEach((link) => {
              link.classList.add('active');
            });
          } else {
            console.warn(`No data-mobile-dropdown-rel found for tab:`, $tab);
          }
        }
      });
      document.querySelectorAll(content).forEach(($content) => {
        if (!$content.previousElementSibling?.classList.contains('active')) {
          $content.classList.remove('active');
          $content.style.height = '0px';
        }
      });
    };

    initializeAccordion();

    // Add click event listener to tabs
    document.querySelectorAll(tab).forEach(($tab) => {
      $tab.addEventListener('click', (e) => {
        e.preventDefault();

        const $content = $tab.nextElementSibling;
        if (!$content || !$content.matches(content)) {
          console.warn(`Content not found for tab:`, $tab);
          return;
        }

        // Get the data-mobile-dropdown-rel value
        const relValue = $tab.parentElement?.getAttribute('data-mobile-dropdown-rel');

        // Check if the clicked tab is already active
        const isActive = $tab.classList.contains('active');

        // Close all other tabs, contents, and CTAs
        document.querySelectorAll(tab).forEach(($otherTab) => {
          if ($otherTab !== $tab) {
            $otherTab.classList.remove('active');
            const $otherContent = $otherTab.nextElementSibling;
            if ($otherContent && $otherContent.matches(content)) {
              $otherContent.classList.remove('active');
              $otherContent.style.height = '0px';
            }
          }
        });

        // Remove active class from all CTAs
        document.querySelectorAll('.menu__cta').forEach((link) => {
          link.classList.remove('active');
        });

        // Toggle current tab and content
        $tab.classList.toggle('active');
        $content.style.overflow = 'hidden';
        $content.style.transition = 'height 0.5s ease-in-out';

        if (isActive) {
          $content.classList.remove('active');
          $content.style.height = '0px';
          document.querySelectorAll('.menu__cta:not([data-dropdown-rel-cta])').forEach((link) => {
            link.classList.add('active');
          });
        } else {
          $content.classList.add('active');
          $content.style.height = `${$content.scrollHeight}px`;

          if (relValue) {
            const ctaLinks = document.querySelectorAll(`.menu__cta[data-dropdown-rel-cta="${relValue}"]`);
            if (ctaLinks.length > 0) {
              ctaLinks.forEach((link) => {
                link.classList.add('active');
              });
            } else {
              document.querySelectorAll('.menu__cta:not([data-dropdown-rel-cta])').forEach((link) => {
                link.classList.add('active');
              });
            }
          } else {
            document.querySelectorAll('.menu__cta:not([data-dropdown-rel-cta])').forEach((link) => {
              link.classList.add('active');
            });
          }

          $content.addEventListener(
            'transitionend',
            () => {
              if ($content.classList.contains('active')) {
                $content.style.height = 'auto';
              }
            },
            { once: true }
          );
        }
      });
    });
  };

  const mobileParentActiveAccordion = (container, tab, content) => {
    const $container = document.querySelector(container);
    const $tab = $container.querySelectorAll(tab);
    const $content = $container.querySelectorAll(content);
  
    // Toggle initial active tab content
    document.querySelectorAll(`${tab}.active`).forEach(($tab) => {
      const $content = $tab.parentElement.nextElementSibling;
      $content.style.display = $content.style.display === 'none' ? 'block' : 'none';
    });
  
    // Add click event listener to tabs
    document.querySelectorAll(tab).forEach(($tab) => {
      $tab.addEventListener('click', (e) => {
        e.preventDefault();
        $tab.classList.toggle('active');
        const $content = $tab.parentElement.nextElementSibling;
        $content.style.display = $content.style.display === 'none' ? 'block' : 'none';
        //$content.classList.remove('hidden');
      });
    });
  };

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = window.innerWidth;

  window.is_touch_device = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  };

  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = window.innerWidth;
        // Run our resize functions
        if (window.Shopify.media_queries.reposive.matches && currentScreenWidth !== beforeResizeWidth) {
          if (!window.is_touch_device()) {
            unload();
            loadMegaMenu();
          }
        }
      }, 66);
    }
  }, false);

  document.addEventListener('shopify:section:unload', (e) => {
    const target = e.target;
    const parentSection = document.querySelector(`#shopify-section-${e.detail.sectionId}`);
  
    if (parentSection.classList.contains('shopify-section--header')) {
      unload(target);
      unloadMegaMenu();
    }
  
    if (parentSection.classList.contains('shopify-section--mega-menu')) {
      unloadMegaMenu();
    }
  });

  const handleSectionSelect = (e) => {
    const parentSection = document.querySelector(`#shopify-section-${e.detail.sectionId}`);
    
    if (parentSection?.classList.contains('shopify-section--mega-menu')) {
      const megaMenuParent = document.querySelector(`.header .${e.detail.sectionId}`)?.dataset.dropdown;
      if (megaMenuParent) {
        setTimeout(() => {
          document.querySelectorAll(`a.mega-menu-parent[data-dropdown-rel="${megaMenuParent}"]`).forEach(link => {
            link.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
            link.closest('header')?.classList.add('editor-hover--true');
          });
          removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
        }, 10);
      }
    }
  };

  const handleSectionDeselect = (e) => {
    const parentSection = document.querySelector(`#shopify-section-${e.detail.sectionId}`);
    
    if (parentSection?.classList.contains('shopify-section--mega-menu')) {
      const megaMenuParent = document.querySelector(`.header .${e.detail.sectionId}`)?.dataset.dropdown;
      if (megaMenuParent) {
        document.querySelectorAll(`a.mega-menu-parent[data-dropdown-rel="${megaMenuParent}"]`).forEach(link => {
          link.dispatchEvent(new MouseEvent('mouseout', { bubbles: true }));
          link.closest('header')?.classList.remove('editor-hover--true');
        });
      }
    }
  };

  document.addEventListener('shopify:section:select', handleSectionSelect);
  document.addEventListener('shopify:section:deselect', handleSectionDeselect);

  if (isTouchDevice() && Shopify.media_queries.reposive.matches || Shopify.media_queries.reposive.matches) {
    document.querySelectorAll('.dropdown_link, .vertical--dropdown').forEach(link => {
      link.dataset.noInstant = 'true';
      link.addEventListener('click', (e) => {
        const header = document.querySelector('#header');
        let dropdown;
        if (header?.offsetParent) {
          dropdown = link.closest('#header')?.querySelector(`[data-dropdown="${link.dataset.dropdownRel}"]`);
        } else {
          if (link.classList.contains('icon-search')) {
            window.location = link.getAttribute('href');
            return false;
          }
          dropdown = link.closest('.main-nav')?.querySelector(`[data-dropdown="${link.dataset.dropdownRel}"]`);
        }

        document.querySelectorAll('.nav a').forEach(a => a.classList.remove('active_link'));

        if (dropdown?.offsetParent || !dropdown) {
          if (dropdown) dropdown.style.display = 'none';
          document.body.classList.remove('is-active');
        } else {
          document.querySelectorAll('.dropdown_container').forEach(container => container.style.display = 'none');
          if (!link.classList.contains('cart-container')) {
            document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.remove('feature_image'));
          }
          dropdown.style.display = 'block';
          document.body.classList.add('is-active');
        }

        if (dropdown?.offsetParent) {
          e.stopPropagation();
          return false;
        }
      });
    });

    document.querySelectorAll('.mobile_nav').forEach(nav => {
      nav.addEventListener('click', () => {
        nav.querySelector('span')?.classList.toggle('open');
      });
    });
  } else {
    if (openDropdownOnClick.length || isTouchDevice()) {
      document.querySelectorAll('.dropdown_link').forEach(link => {
        link.dataset.clickCount = '0';
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const dropdown = link.closest('.main-nav')?.querySelector(`[data-dropdown="${link.dataset.dropdownRel}"]`);
          if (!dropdown) return;
          let clickCount = parseInt(link.dataset.clickCount) || 0;

          closeAllSubmenus();
          closeDropdown();
          document.querySelectorAll('.dropdown_link').forEach(otherLink => {
            if (otherLink !== link) otherLink.dataset.clickCount = '0';
            otherLink.dataset.noInstant = 'true';
          });
          document.querySelectorAll('.active_link').forEach(active => active.classList.remove('active_link'));

          if (!link.classList.contains('active_link')) {
            dropdown.style.display = 'block';
            if (link.classList.contains('mini_cart')) {
              if (!document.body.classList.contains('cart')) {
                link.parentElement.classList.add('active_link');
              }
            } else {
              link.classList.add('active_link');
              document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.remove('feature_image'));
            }
          }

          clickCount++;
          link.dataset.clickCount = clickCount;
          if (clickCount < 2) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      });
    }

    const closeDropdowns = () => {
      document.querySelectorAll('.dropdown_container').forEach(container => container.style.display = 'none');
      document.querySelectorAll('.active_link').forEach(active => active.classList.remove('active_link'));
      document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.add('feature_image'));
      document.body.classList.remove('is-active');
    }

    if (!openDropdownOnClick.length) {
      document.querySelectorAll('.header-desktop-logo, .header-desktop-options, .header-desktop-nav a, .nav a, .logo a').forEach(link => {
        if (!link.closest('.cart_content')) {
          link.addEventListener('mouseenter', () => {
            if (!link.classList.contains('active_link')) {
              closeDropdowns()
            }
          });
        }
      });

      document.querySelectorAll('.header-desktop, .main-nav, .top-bar, .cart-container').forEach(element => {
        element.addEventListener('mouseleave', closeDropdowns)
      });

      document.querySelectorAll('.dropdown_link').forEach(element => {
        element.addEventListener('mouseover', (e) => {
          const current = e.currentTarget;
          const dropdown = document.querySelector(`[data-dropdown="${element.dataset.dropdownRel}"]`);
          document.querySelectorAll('.dropdown_container').forEach(container => container.style.display = 'none');
          document.querySelectorAll('.active_link').forEach(link => link.classList.remove('active_link'));
          if (!dropdown) return
          if (!element.classList.contains('active_link')) {
            dropdown.style.display = 'block';
            current.classList.add('active_link');
            document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.add('feature_image'));
            if (current.classList.contains('mini_cart')) {
              if (!document.body.classList.contains('cart')) {
                current.parentElement.classList.add('active_link');
              }
            } else {
              current.classList.add('active_link');
              document.querySelectorAll('.is-absolute').forEach(abs => abs.parentElement.classList.remove('feature_image'));
            }
          }
        });
      });
    }
  }

  mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');
  } catch(e) { console.error(e); }
})();

})();
